import { useEffect, useRef, useState } from "react";
import { CheckCircle, Trash2, UploadIcon } from "lucide-react";
// import { Progress } from "../components/ui/progress";
import { cn } from "../lib/utils";
import axios from "axios";
import { toast } from "sonner";
import { BaseUrlApi, UrlImage } from "../lib/api";
import { Progress } from "antd";
import { Button } from "./ui/button";

const FileIcon = ({ fileType, className }) => {
  // Define gradients and icon paths based on file type
  let gradientId, gradientColors, iconPath;

  if (fileType.startsWith("image/")) {
    gradientId = "imageGradient";
    gradientColors = [
      { offset: "0%", color: "#FF5E98" },
      { offset: "100%", color: "#903AFF" },
    ];
    iconPath =
      "M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5zm5-11h-2V5h4v4h-2V7z";
  } else if (fileType.startsWith("audio/")) {
    gradientId = "audioGradient";
    gradientColors = [
      { offset: "0%", color: "#00E1FD" },
      { offset: "100%", color: "#FC007A" },
    ];
    iconPath =
      "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6zm-2 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z";
  } else if (fileType.startsWith("video/")) {
    gradientId = "videoGradient";
    gradientColors = [
      { offset: "0%", color: "#FF3366" },
      { offset: "100%", color: "#FF9933" },
    ];
    iconPath =
      "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z";
  } else if (fileType === "application/pdf") {
    gradientId = "pdfGradient";
    gradientColors = [
      { offset: "0%", color: "#FF3D00" },
      { offset: "100%", color: "#FF8A00" },
    ];
    iconPath =
      "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h2c.83 0 1.5.67 1.5 1.5v3zm4-3.75c0 .41-.34.75-.75.75H19v1h.75c.41 0 .75.34.75.75s-.34.75-.75.75H19v1h.75c.41 0 .75.34.75.75s-.34.75-.75.75H18c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h2.25c.41 0 .75.34.75.75zM15 10.5v-3H14v3h1zM10 9H9v1h1V9z";
  } else if (
    [
      "application/zip",
      "application/x-rar-compressed",
      "application/x-7z-compressed",
    ].includes(fileType)
  ) {
    gradientId = "archiveGradient";
    gradientColors = [
      { offset: "0%", color: "#FFCF00" },
      { offset: "100%", color: "#FF5E00" },
    ];
    iconPath =
      "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2z";
  } else if (
    [
      "text/html",
      "application/javascript",
      "text/css",
      "application/json",
      "text/plain",
    ].includes(fileType)
  ) {
    gradientId = "codeGradient";
    gradientColors = [
      { offset: "0%", color: "#00C6FB" },
      { offset: "100%", color: "#005BEA" },
    ];
    iconPath =
      "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z";
  } else if (fileType.startsWith("text/")) {
    gradientId = "textGradient";
    gradientColors = [
      { offset: "0%", color: "#8A2BE2" },
      { offset: "100%", color: "#4B0082" },
    ];
    iconPath =
      "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z";
  } else if (
    fileType.startsWith(
      "application/vnd.openxmlformats-officedocument.spreadsheetml"
    ) ||
    fileType.includes("excel")
  ) {
    gradientId = "excelGradient";
    gradientColors = [
      { offset: "0%", color: "#1D976C" },
      { offset: "100%", color: "#93F9B9" },
    ];
    iconPath =
      "M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1.99 6H17L14.5 14h2.51l-2.5 5H7.5l2.5-5H7.5L10 9h7.01z";
  } else if (
    fileType.startsWith(
      "application/vnd.openxmlformats-officedocument.wordprocessingml"
    ) ||
    fileType.includes("word")
  ) {
    gradientId = "wordGradient";
    gradientColors = [
      { offset: "0%", color: "#2193b0" },
      { offset: "100%", color: "#6dd5ed" },
    ];
    iconPath =
      "M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.99 6H17L14.5 14h2.51l-2.5 5H7.5l2.5-5H7.5L10 9h5.01z";
  } else if (
    fileType.startsWith(
      "application/vnd.openxmlformats-officedocument.presentationml"
    ) ||
    fileType.includes("powerpoint")
  ) {
    gradientId = "pptGradient";
    gradientColors = [
      { offset: "0%", color: "#FF512F" },
      { offset: "100%", color: "#DD2476" },
    ];
    iconPath =
      "M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z";
  } else {
    gradientId = "fileGradient";
    gradientColors = [
      { offset: "0%", color: "#5B86E5" },
      { offset: "100%", color: "#36D1DC" },
    ];
    iconPath =
      "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z";
  }

  // Create a unique ID for each icon instance to prevent gradient conflicts
  const uniqueId = `${gradientId}_${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      fill={`url(#${uniqueId})`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={uniqueId} x1="0%" y1="0%" x2="100%" y2="100%">
          {gradientColors.map((stop, index) => (
            <stop key={index} offset={stop.offset} stopColor={stop.color} />
          ))}
        </linearGradient>
      </defs>
      <path d={iconPath} />
    </svg>
  );
};

// Get file extension from name
const getFileExtension = (filename) => {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
};

// Function to check if a string is a valid URL
const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

// Function to determine if a URL is an image
const isImageUrl = (url) => {
  return /\.(jpeg|jpg|gif|png|webp|svg|avif|bmp|tiff)$/i.test(url);
};

// Function to get file type from URL or path
const getFileTypeFromUrl = (url) => {
  const extension = url.split(".").pop().toLowerCase();

  const extensionMap = {
    // Images
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    avif: "image/avif",
    bmp: "image/bmp",
    tiff: "image/tiff",

    // Documents
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",

    // Archives
    zip: "application/zip",
    rar: "application/x-rar-compressed",
    "7z": "application/x-7z-compressed",

    // Text
    txt: "text/plain",
    html: "text/html",
    css: "text/css",
    js: "application/javascript",
    json: "application/json",

    // Audio
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",

    // Video
    mp4: "video/mp4",
    webm: "video/webm",
    avi: "video/x-msvideo",
  };

  return extensionMap[extension] || "application/octet-stream";
};

export default function MultiFileUpload({
  onUploadComplete,
  onUploading,
  name = "file",
  initialFiles = [],
  disabled = false,
  maxFiles = 10,
  maxFileSize = 1000, // Max file size in MB
  acceptedFileTypes = "*", // Accept all file types by default
  baseApiUrl = BaseUrlApi, // Default API endpoint
  urlImage = UrlImage, // Base URL for images
}) {
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  // Initialize with initial files if provided
  useEffect(() => {
    if (initialFiles && initialFiles.length > 0) {
      const initialFileStates = initialFiles
        .filter((file) => file) // Filter out null/undefined
        .map((file, index) => {
          // Determine if the file is a URL or a relative path
          const fileUrl = isValidUrl(file)
            ? file
            : urlImage
            ? `${urlImage}/${file}`
            : file;
          const fileIsImage = isImageUrl(fileUrl);
          const fileType = getFileTypeFromUrl(fileUrl);

          // Extract filename from URL or path
          const fileName = fileUrl.split("/").pop() || `file-${index}`;

          return {
            id: `initial-${index}`,
            file: {
              name: fileName,
              size: 0,
              type: fileType,
            }, // Mock file object
            preview: fileUrl,
            uploading: false,
            progress: 100,
            uploadedUrl: fileUrl,
            error: null,
            type: fileIsImage ? "image" : "file",
            fileType: fileType,
            name: fileName,
          };
        });

      setFiles(initialFileStates);
    }
  }, [initialFiles, urlImage]);

  // Cleanup previews on unmount
  useEffect(() => {
    onUploading &&
      onUploading(files.filter((item) => item.uploading === true).length !== 0);

    return () => {
      files.forEach((file) => {
        if (
          file.preview &&
          typeof file.preview === "string" &&
          file.preview.startsWith("blob:")
        ) {
          URL.revokeObjectURL(file.preview);
        }
      });
    };
  }, [files]);

  const handleUpload = async (file) => {
    const fileId = crypto.randomUUID();
    const fileType = file.type || `application/${getFileExtension(file.name)}`;
    const isImage = fileType.startsWith("image/");

    // Add file to state
    setFiles((prev) => [
      ...prev,
      {
        id: fileId,
        file,
        preview: isImage ? URL.createObjectURL(file) : null,
        uploading: true,
        progress: 0,
        uploadedUrl: null,
        error: null,
        type: isImage ? "image" : "file",
        fileType,
        name: file.name,
        size: file.size,
      },
    ]);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);

    try {
      const response = await axios.post(`${baseApiUrl}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            setFiles((prev) =>
              prev.map((f) =>
                f.id === fileId ? { ...f, progress: percentCompleted } : f
              )
            );
          }
        },
      });

      if (response.data && response.data.url) {
        setFiles((prev) =>
          prev.map((f) =>
            f.id === fileId
              ? {
                  ...f,
                  uploading: false,
                  progress: 100,
                  uploadedUrl: response.data.url,
                }
              : f
          )
        );

        // Notify parent component of all uploaded files
        if (onUploadComplete) {
          const uploadedUrls = files
            .filter((f) => f.id !== fileId && f.uploadedUrl)
            .map((f) => f.uploadedUrl)
            .concat(response.data.url);

          onUploadComplete((prev) => [...prev, response.data.url]);
        }

        toast("Success", {
          description: "File uploaded successfully",
        });
      } else {
        throw new Error("Upload failed");
      }
    } catch (error) {
      setFiles((prev) =>
        prev.map((f) =>
          f.id === fileId
            ? {
                ...f,
                uploading: false,
                error: "Upload failed. Please try again.",
              }
            : f
        )
      );

      toast("Error", {
        description: "Upload failed. Please try again.",
      });
    }
  };

  const removeFile = (fileId) => {
    const fileToRemove = files.find((f) => f.id === fileId);

    // Revoke object URL if it's a local preview
    if (
      fileToRemove?.preview &&
      typeof fileToRemove.preview === "string" &&
      fileToRemove.preview.startsWith("blob:")
    ) {
      URL.revokeObjectURL(fileToRemove.preview);
    }

    // Remove file from state
    setFiles((prev) => prev.filter((f) => f.id !== fileId));

    // Notify parent component
    if (onUploadComplete) {
      const remainingUrls = files
        .filter((f) => f.id !== fileId && f.uploadedUrl)
        .map((f) => f.uploadedUrl);

      onUploadComplete(remainingUrls);
    }
  };

  const handleFilesChange = (event) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles || files.length >= maxFiles) return;

    // Check if adding these files would exceed the max
    const availableSlots = maxFiles - files.length;
    const filesToUpload = Array.from(selectedFiles).slice(0, availableSlots);

    // Upload each file
    filesToUpload.forEach((file) => {
      if (validateFile(file)) {
        handleUpload(file);
      }
    });

    // Reset input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validateFile = (file) => {
    // Check file size
    const fileSizeMB = file.size / 1024 / 1024;
    if (fileSizeMB > maxFileSize) {
      toast("File too large", {
        description: `File must be smaller than ${maxFileSize}MB!`,
      });
      return false;
    }

    // Check file type if acceptedFileTypes is specified and not "*"
    if (acceptedFileTypes !== "*") {
      const acceptedTypes = acceptedFileTypes
        .split(",")
        .map((type) => type.trim());
      const fileType = file.type;

      // Check if the file type matches any of the accepted types
      const isAccepted = acceptedTypes.some((type) => {
        // Handle wildcards like "image/*"
        if (type.endsWith("/*")) {
          const category = type.split("/")[0];
          return fileType.startsWith(`${category}/`);
        }
        return type === fileType;
      });

      if (!isAccepted) {
        toast("Invalid file type", {
          description: "This file type is not supported!",
        });
        return false;
      }
    }

    return true;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    if (disabled || files.length >= maxFiles) return;

    if (event.dataTransfer.files.length > 0) {
      const availableSlots = maxFiles - files.length;
      const filesToUpload = Array.from(event.dataTransfer.files).slice(
        0,
        availableSlots
      );

      filesToUpload.forEach((file) => {
        if (validateFile(file)) {
          handleUpload(file);
        }
      });
    }
  };

  // Format file size for display
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
    );
  };

  // Render file preview or icon
  const renderFilePreview = (fileObj) => {
    if (fileObj.type === "image" && fileObj.preview) {
      return (
        <img
          src={fileObj.preview || "/placeholder.svg"}
          alt={fileObj.file.name || "File preview"}
          className="w-full h-full object-cover"
        />
      );
    } else {
      return (
        <div className="flex flex-col items-center justify-center w-full h-full bg-muted/30 p-4">
          <FileIcon fileType={fileObj.fileType} className="h-16 w-16" />
          <span className="text-xs text-muted-foreground mt-2 truncate max-w-full">
            {fileObj.name || fileObj.file.name || "File"}
          </span>
        </div>
      );
    }
  };

  return (
    <div className="space-y-4">
      <div
        className={cn(
          "flex flex-col items-center justify-center border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors duration-300 ease-in-out min-h-40 hover:border-blue-600",
          isDragging ? "bg-primary/10" : "",
          disabled ? "opacity-50 cursor-not-allowed" : ""
        )}
        onClick={() => !disabled && fileInputRef.current?.click()}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={!disabled ? handleDrop : undefined}
      >
        {files.length === 0 ? (
          <>
            <UploadIcon className="mx-auto h-16 w-16 text-muted-foreground mb-4" />
            <p className="text-sm text-muted-foreground">
              Drag and drop files here, or click to select files.
            </p>
            {acceptedFileTypes !== "*" && (
              <p className="text-xs text-muted-foreground mt-2">
                Accepted file types: {acceptedFileTypes}
              </p>
            )}
            <p className="text-xs text-muted-foreground mt-1">
              Maximum file size: {maxFileSize}MB
            </p>
          </>
        ) : (
          <div className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-4">
              {files.map((fileObj) => (
                <div
                  key={fileObj.id}
                  className="relative aspect-square rounded-md overflow-hidden border"
                >
                  {renderFilePreview(fileObj)}

                  {/* Upload status indicator */}
                  {fileObj.uploading && (
                    <div className="absolute inset-0 bg-background/80 flex items-center justify-center">
                      <div className="text-center">
                        <p className="text-xs font-medium mb-1">
                          {fileObj.progress}%
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Success indicator */}
                  {fileObj.uploadedUrl && !fileObj.uploading && (
                    <div className="absolute top-1 right-1 bg-background/80 rounded-full p-0.5">
                      <CheckCircle className="h-4 w-4 text-green-500" />
                    </div>
                  )}

                  {/* Remove button */}
                  <Button
                    variant="destructive"
                    size="icon"
                    className="absolute bottom-1 right-1 h-6 w-6 rounded-full"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFile(fileObj.id);
                    }}
                    disabled={disabled}
                  >
                    <Trash2 className="h-3 w-3" />
                  </Button>
                </div>
              ))}

              {/* Add more button */}
              {files.length < maxFiles && (
                <div
                  className="flex items-center justify-center aspect-square rounded-md border-2 border-dashed cursor-pointer hover:bg-muted/50"
                  onClick={(e) => {
                    e.stopPropagation();
                    !disabled && fileInputRef.current?.click();
                  }}
                >
                  <UploadIcon className="h-8 w-8 text-muted-foreground" />
                </div>
              )}
            </div>

            <p className="text-sm text-muted-foreground mt-2">
              Click to add more files or drag and drop here.
            </p>
          </div>
        )}
      </div>

      {/* File Upload Progress List */}
      {files.length > 0 && (
        <div className="space-y-2">
          {files.map((fileObj) => (
            <div key={fileObj.id} className="relative">
              <div className="flex items-center gap-2 p-2 border rounded-md">
                {/* File icon */}
                <div className="flex-shrink-0">
                  <FileIcon fileType={fileObj.fileType} className="h-6 w-6" />
                </div>

                {/* File info */}
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-start">
                    <span className="text-sm font-medium truncate">
                      {fileObj.file.name || fileObj.name || "File"}
                    </span>
                    <span className="text-xs text-muted-foreground ml-2">
                      {formatFileSize(fileObj.file.size || fileObj.size || 0)}
                    </span>
                  </div>

                  <Progress percent={fileObj.progress} className="h-1 mt-1" />
                </div>

                {/* Remove button */}
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => removeFile(fileObj.id)}
                  className="flex-shrink-0 h-8 w-8 hover:bg-muted"
                  disabled={disabled}
                >
                  <Trash2 className="h-4 w-4 text-muted-foreground" />
                </Button>
              </div>

              {fileObj.error && (
                <div className="text-destructive text-xs mt-1 px-2">
                  {fileObj.error}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <input
        type="file"
        className="sr-only"
        disabled={disabled || files.length >= maxFiles}
        ref={fileInputRef}
        onChange={handleFilesChange}
        multiple
        accept={acceptedFileTypes}
      />
    </div>
  );
}
